<template>
  <Layout>
    <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />

    <div class="flex justify-between mb-5">
      <GoBack
        class="my-auto"
        text="shottracker news"
        link="Media"
        location="press-releases"
      />
      <AdminOnly v-if="!loading.status">
        <AdminOptions
          v-if="!deleteClicked"
          @deleteClicked="deleteClicked = !deleteClicked"
          @editClicked="editClicked"
        />
        <div v-if="deleteClicked">
          <DeleteConfirmation
            @cancelDelete="deleteClicked = !deleteClicked"
            @deleteHandler="deleteHandler"
          />
        </div>
      </AdminOnly>
    </div>

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <PressReleaseDetails
      v-else
      class="bg-white drop-shadow-lg shadow-2xl p-8"
      :file="file"
      :featured="false"
    >
      <MarkdownPreview
        data-aos="fade-in"
        data-aos-easing="ease-in-out"
        data-aos-duration="500"
        :text="file.JSON.body"
      />
    </PressReleaseDetails>
  </Layout>
</template>

<script>
import Layout from "../../Layout.vue";
import GoBack from "../../GoBack.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import PressReleaseDetails from "./PressReleaseDetails.vue";
import MarkdownPreview from "../../MarkdownPreview.vue";
import AdminOnly from "../../AdminOnly.vue";
import DeleteConfirmation from "../../DeleteConfirmation.vue";
import AdminOptions from "../../AdminOptions.vue";
import FeedbackMessage from "../../FeedbackMessage.vue";
import { mapActions, mapGetters } from "vuex";
import loader from "../../../mixins/loader";

export default {
  name: "PressReleasePage",
  mixins: [loader],

  components: {
    Layout,
    GoBack,
    LoadingSpinner,
    PressReleaseDetails,
    MarkdownPreview,
    AdminOptions,
    DeleteConfirmation,
    AdminOnly,
    FeedbackMessage,
  },

  data() {
    return {
      deleteClicked: false,
    };
  },

  computed: {
    ...mapGetters([
      "file",
      "feedback",
      "isAdmin",
      "pressReleasesID",
      "dataDeleted",
    ]),
  },

  methods: {
    ...mapActions(["fetchFile", "deleteFileFromS3", "resetFeedback"]),

    async deleteHandler() {
      const { identifier } = this.file;
      const key = this.pressReleasesID.directoryKey;
      const file = { identifier, key };

      await this.load(this.deleteFileFromS3(file), "Deleting press release");

      if (this.dataDeleted(identifier, key)) {
        this.$router.push({
          name: "Media",
        });
      }
    },

    editClicked() {
      this.$router.push({
        name: "EditPressRelease",
        params: { id: this.file.identifier },
      });
    },
  },

  async created() {
    const identifier = this.$route.params.id;

    await this.load(this.fetchFile(identifier), "Loading press release");

    if (this.file.JSON === "") {
      this.$router.push({
        name: "Media",
      });
    }

    if (!this.isAdmin) {
      const { JSON } = this.file;

      if (JSON.link) {
        window.open(JSON.link, "_blank");

        this.$router.push({
          name: "Media",
        });
      }
    }
  },
};
</script>